module.exports = __webpack_public_path__ + "img/logoWSTC.e001293c.svg";